import React from 'react';

export const Loading = () => {
  return (
    <div className="text-gray-500 text-lg mt-2 mb-1">Loading...</div>
  );
};
